<div class="container" fxLayout="column" fxLayoutAlign="center center" class="p-20">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content>
    <p style="white-space: pre-line; text-align: center;">{{ data.message }}</p>
  </div>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
    <button *ngIf="data.confirmText" mat-flat-button [color]="data?.actionColour ? data.actionColour : 'warn'" [mat-dialog-close]="true" cdkFocusInitial>
      <mat-icon>{{ data.actionIcon }}</mat-icon> {{ data.confirmText }}
    </button>
    <button *ngIf="data?.secondOptionText" mat-flat-button color="accent" (click)="secondOptionConfirm()">
      <mat-icon>{{ data.secondOptionActionIcon }}</mat-icon> {{ data.secondOptionText }}
    </button>
    <button mat-stroked-button color="basic" (click)="cancel()">
      <mat-icon>clear</mat-icon> {{ data.cancelText }}
    </button>
  </div>
</div>
